import { useMutation } from '@apollo/client'

import {
  QUERY_USER_SETTINGS,
  MUTATE_USER_SETTINGS,
} from '~/modules/account/queries'

/**
 *
 */
export default function () {
  const [mutate] = useMutation(MUTATE_USER_SETTINGS)

  return () =>
    mutate({
      optimisticResponse: {
        __typename: 'Mutation',
        engageHideMarkAsReadModal: {
          __typename: 'CommonMutationResponse',
          code: '200',
          success: true,
          message: '',
        },
      },
      update: (cache, { data: { engageHideMarkAsReadModal } }) => {
        const { code, success, message } = engageHideMarkAsReadModal

        // @ts-expect-error TS(2339) FIXME: Property 'engageUserSettings' does not exist on ty... Remove this comment to see the full error message
        const { engageUserSettings } = cache.readQuery({
          query: QUERY_USER_SETTINGS,
        })

        const updatedUserSettings = {
          ...engageUserSettings,
          showMarkAsReadWarningModal: false,
        }

        cache.writeQuery({
          query: QUERY_USER_SETTINGS,
          data: { engageUserSettings: updatedUserSettings },
        })
      },
    })
}
